import styled from 'styled-components'

import { ColumnLabel as DefaultColumnLabel } from '../Shared'

export const ColumnLabel = styled(DefaultColumnLabel).attrs({
	as: 'fieldset',
})`
	margin: 0;
	padding: 0;
	border: none;
`
